import { render, staticRenderFns } from "./SpotList.vue?vue&type=template&id=12adf036&"
import script from "./SpotList.vue?vue&type=script&lang=js&"
export * from "./SpotList.vue?vue&type=script&lang=js&"
import style0 from "./SpotList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports